import { Box, Modal, styled, TextField } from "@mui/material";

export const GuestListButton = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#FB4764",
  borderRadius: "15px",
  color: "#FFFFFF",
  height: "36px",
  width: "122px",
  gap: "8px",
  fontSize: "13px",
  fontWeight: 500,
  cursor: "pointer",
});

export const GuestListModal = styled(Modal)({
  overflowY: "scroll",
  "& .MuiBackdrop-root": {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    backdropFilter: "blur(4px)",
    WebkitBackdropFilter: "blur(4px)",
  },
});

export const ModalContent = styled(Box)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "#fff",
  minWidth: "600px",
  maxHeight: "90dvh",
  borderRadius: "25px",
  boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
});

export const AddGuestButton = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  cursor: "pointer",
  backgroundColor: "#FB4764",
  color: "#FFFFFF",
  borderRadius: "15px",
  fontWeight: 500,
  width: "100%",
  height: "48px",
});

export const CustomTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    height: "44px",
    backgroundColor: "#FFF4F3",
    borderRadius: "10px",
    fontSize: "15px",
    fontWeight: 600,
    "& fieldset": {
      border: "none",
    },
    "&:hover fieldset": {
      border: "none",
    },
    "&.Mui-focused fieldset": {
      border: "none",
    },
  },
});
